const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotarinIconSchenken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 599",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-672.232,-642.361)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,671.875,642.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schenken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.776,340.005C161.504,325.783 167.315,321.338 146.607,338.185",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.82694,0.142376,-0.124038,0.72043,214.905,63.4947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.776,340.005C161.504,325.783 167.315,321.338 146.607,338.185",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "21.48px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.577,446.456L171.283,346.923L319.763,346.923L319.763,466.041",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.262,406.482L319.763,406.482",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.013,346.923L245.013,447.379",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.888688,0,0,0.892799,3.40154,20.9547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.83,289.465C263.829,289.465 282.501,308.137 282.501,331.136C282.501,354.135 263.829,372.807 240.83,372.807C217.831,372.807 199.159,354.135 199.159,331.136C199.159,308.137 217.831,289.465 240.83,289.465ZM240.83,308.399C228.305,308.399 218.18,318.611 218.18,331.136C218.18,343.661 228.305,353.874 240.83,353.874C253.355,353.874 263.48,343.661 263.48,331.136C263.48,318.611 253.355,308.399 240.83,308.399Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.701728,0,0,0.696963,102.119,89.886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.83,289.465C263.829,289.465 282.501,308.137 282.501,331.136C282.501,354.135 263.829,372.807 240.83,372.807C217.831,372.807 199.159,354.135 199.159,331.136C199.159,308.137 217.831,289.465 240.83,289.465ZM240.83,313.719C231.171,313.719 223.248,321.477 223.248,331.136C223.248,340.795 231.171,348.554 240.83,348.554C250.489,348.554 258.412,340.795 258.412,331.136C258.412,321.477 250.489,313.719 240.83,313.719Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.821,408.114L113.051,407.659L160.382,446.343L271.884,447.708C293.658,452.625 302.599,477.077 277.346,495.495L226.828,497.316L208.624,514.155",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20951,0,0,1.07035,-10.6323,-30.5034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.508,393.152L74.508,534.663L9.086,534.663L9.086,393.152L74.508,393.152ZM60.533,408.945C60.533,408.945 23.062,408.945 23.062,408.945C23.062,408.945 23.062,518.87 23.062,518.87C23.062,518.87 60.533,518.87 60.533,518.87L60.533,408.945Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.486,521.152L90.153,521.152L216.162,590.13L381.907,500.217C421.286,478.046 389.064,437.034 356.677,453.71L286.419,489.863",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,600.357,-279.389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.776,340.005C161.504,325.783 167.315,321.338 146.607,338.185",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82694,0.142376,0.124038,0.72043,385.452,-215.894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.776,340.005C161.504,325.783 167.315,321.338 146.607,338.185",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "21.48px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,600.357,-279.389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.577,446.456L171.283,346.923L319.763,346.923L319.763,466.041",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,600.357,-279.389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.262,406.482L319.763,406.482",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,600.357,-279.389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.013,346.923L245.013,447.379",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.888688,0,0,0.892799,596.956,-258.434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.83,289.465C217.831,289.465 199.159,308.137 199.159,331.136C199.159,354.135 217.831,372.807 240.83,372.807C263.829,372.807 282.501,354.135 282.501,331.136C282.501,308.137 263.829,289.465 240.83,289.465ZM240.83,308.399C253.355,308.399 263.48,318.611 263.48,331.136C263.48,343.661 253.355,353.874 240.83,353.874C228.305,353.874 218.18,343.661 218.18,331.136C218.18,318.611 228.305,308.399 240.83,308.399Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.701728,0,0,0.696963,498.239,-189.503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.83,289.465C217.831,289.465 199.159,308.137 199.159,331.136C199.159,354.135 217.831,372.807 240.83,372.807C263.829,372.807 282.501,354.135 282.501,331.136C282.501,308.137 263.829,289.465 240.83,289.465ZM240.83,313.719C250.489,313.719 258.412,321.477 258.412,331.136C258.412,340.795 250.489,348.554 240.83,348.554C231.171,348.554 223.248,340.795 223.248,331.136C223.248,321.477 231.171,313.719 240.83,313.719Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,600.357,-279.389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.821,408.114L113.051,407.659L160.382,446.343L271.884,447.708C293.658,452.625 302.599,477.077 277.346,495.495L226.828,497.316L208.624,514.155",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.20951,0,0,1.07035,610.99,-309.892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.508,393.152L9.086,393.152L9.086,534.663L74.508,534.663L74.508,393.152ZM60.533,408.945C60.533,408.945 60.533,518.87 60.533,518.87C60.533,518.87 23.062,518.87 23.062,518.87C23.062,518.87 23.062,408.945 23.062,408.945L60.533,408.945Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,600.357,-279.389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.486,521.152L90.153,521.152L216.162,590.13L381.907,500.217C421.286,478.046 389.064,437.034 356.677,453.71L286.419,489.863",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotarinIconSchenken);
export default __webpack_public_path__ + "static/media/Notarin_Icon_Schenken.8f62d5eeb50f72585d2ad9c956aa1a27.svg";
export { ForwardRef as ReactComponent };